import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import MainMeAll from './MainMeAll';
import WidgetsDropdown from '../../layout/WidgetsDropdown';
import Tooltip from '@mui/material/Tooltip';
import ProductivityBar from '../../components/chart/ProductivityBar';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import ActivityDashboard from '../../components/ActivityDashboard';
import UserActivity from '../../components/UserActivity';
import SingleDatePicker from '../../components/Date-range-picker/SingleDatePicker';
import { Link } from "react-router-dom";
import MeHeaderStats from './MeHeaderStats';
import AllTabsData from './AllTabsData';
import MeTabsData from './MeTabsData';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const MainTabPanel = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const myWidgetOptions1 = {
    'Small widgets': [
      'Active Users',
      "Avg. Worked Time",
      "Today's activity",
      'Worked today',
      'Avg. Idle Time',
      'Weekly activity',
      'Worked this week',
      'Avg. Focus Time',
      'Projects worked',
      'Spent today',
    ],
    'Large widgets': [
      'Amounts owed',
      'Apps & URLs',
      'Client Budgets',
      'Pending Payments',
      'Insights',
      'Invoices',
      'Late & Missed Shifts',
      'Last week',
      'Low activity',
      'Manual Time',
      'Members',
      'Project Budgets',
      'Projects',
      'Recent activity',
      'This week',
      'Time off requested',
      'Timesheets to approve',
      'Upcoming time off',
      'Weekly limits',]
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box className="d-flex justify-content-between align-items-center" sx={{ flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'nowrap', xs: 'wrap' } }}>
        <Box sx={{ marginBottom: { xl: '0', lg: '0', md: '0', sm: '0', xs: '10px' }, borderBottom: 1, borderColor: 'divider', display: 'inline-block' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab label="Me" {...a11yProps(0)} />
            <Tab label="All" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <Box className='d-flex align-items-center gap-2' >
          {
            value === 1 && (
              <SingleDatePicker />
            )
          }
          <WidgetsDropdown widgetOptions={myWidgetOptions1} />
        </Box>
      </Box>

      {/* //Me tab// */}
      <CustomTabPanel value={value} index={0} sx={{}}>
        <MeHeaderStats />
        <div className='card-body p-20 bg-base border rounded-3 mt-24'>
          <div className="card-header bg-base pb-24 d-flex align-items-center justify-content-between">
            <h6 className=" fw-semibold mb-0" style={{ fontSize: '17px' }}>Productivity bar<Tooltip title="Productivity bar" arrow placement="top">
              <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                <InfoOutlineIcon fontSize="small" />
              </button>
            </Tooltip></h6>
          </div>
          <ProductivityBar />
        </div>
        <div className='card-body p-20 bg-base border rounded-3 UserAdminViw mt-24'>
          <Box display="flex" justifyContent="space-between" className=" pb-16 border-bottom" sx={{
            marginBottom: '25px'
          }}>
            <h6 className=" fw-semibold mb-0" style={{ fontSize: '17px' }}>Recent activity Screenshots  <Tooltip title="Recent activity Screenshots" arrow placement="top">
              <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                <InfoOutlineIcon fontSize="small" />
              </button>
            </Tooltip></h6>
            <a href="/screenshorts" style={{ cursor: "pointer", fontSize: '14px', color: '#004DFF', }}>  View report</a>
            {/* <Link to="/screenshorts"
           
            >
            
            </Link> */}
          </Box>
          <UserActivity showSummary={false} limit={6} />
        </div>
        <MeTabsData />
      </CustomTabPanel>

      {/* //all tabs // */}
      <CustomTabPanel value={value} index={1}>
        <MainMeAll />
        <div className='card-body p-20 bg-base border rounded-3 mt-24'>
          <div className="card-header bg-base pb-24 d-flex align-items-center justify-content-between">
            <h6 className=" fw-semibold mb-0" style={{ fontSize: '17px' }}>Productivity bar   <Tooltip title="Productivity bar" arrow placement="top">
              <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                <InfoOutlineIcon fontSize="small" />
              </button>
            </Tooltip></h6>
          </div>
          <ProductivityBar /></div>

        <div className='card-body p-20 bg-base border rounded-3 UserAdminViw mt-24'>
          <h6 className=" fw-semibold pb-16 mb-24 border-bottom" style={{ fontSize: '17px' }}>Recent activity Screenshots  <Tooltip title="Recent activity Screenshots" arrow placement="top">
            <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
              <InfoOutlineIcon fontSize="small" />
            </button>
          </Tooltip></h6>
          <Box className='' sx={{
            display: 'grid',
            gridTemplateColumns: `repeat(2, 1fr)`,
            gap: '20px 0',
          }}><ActivityDashboard />
          </Box>
        </div>

        <AllTabsData />
      </CustomTabPanel>
    </Box>
  );
};

export default MainTabPanel;
